import {
  ChangeEvent,
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
  Modal,
  Button,
  Select,
  SelectChangeEvent,
  MenuItem,
  Autocomplete,
  Checkbox,
  Chip,
} from "@mui/material";
import * as Yup from "yup";
import { useLazyGetMasterDataQuery } from "../services/category";
import { Category } from "../types/General";
import { showError } from "../constants/toasts";
import useTranslation from "../hooks/traslation";
import { isValidInput } from "../utils/validations";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

// const serviceSchema = Yup.object().shape({
//   name: Yup.string()
//     .required("name is required")
//     .min(2, "name must be at least 2 characters")
//     .max(50, "name must not exceed 50 characters"),
//   price: Yup.string()
//     .required("Price is required")
//     .test("is-valid-price", "Please enter a valid price", (value) => {
//       if (!value) return false;
//       return /^\d*\.?\d*$/.test(value);
//     }),
//   description: Yup.string()
//     .required("Description is required")
//     .min(10, "Description must be at least 10 characters")
//     .max(500, "Description must not exceed 500 characters"),
// });

interface AddServiceProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  handleSubmit: () => void;
  name: string;
  setName: Dispatch<SetStateAction<string>>;
  price: string;
  setPrice: Dispatch<SetStateAction<string>>;
  description: string;
  setDescription: Dispatch<SetStateAction<string>>;
  selectedId: string;
  setSelectedId: Dispatch<SetStateAction<string>>;
  cateId: string | undefined;
  selectedService: string[];
  setSelectedService: Dispatch<SetStateAction<string[]>>;

  name_ar: string;
  description_ar: string;
  setName_ar: Dispatch<SetStateAction<string>>;
  setDescription_ar: Dispatch<SetStateAction<string>>;
}

export default function AddService({
  open,
  onClose,
  setOpen,
  handleSubmit,
  name,
  setName,
  price,
  setPrice,
  description,
  setDescription,
  selectedId,
  setSelectedId,
  cateId,
  selectedService,
  setSelectedService,
  description_ar,
  name_ar,
  setDescription_ar,
  setName_ar,
}: AddServiceProps) {
  const [error, setError] = useState(false);
  const [getMasterMethod] = useLazyGetMasterDataQuery();
  const [selectField1, setSelectField1] = useState("");
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const translate = useTranslation();

  const serviceSchema = Yup.object().shape({
    name: Yup.string()
      .required(translate?.error?.required)
      .min(2, translate?.auth?.subServiceCharLen_min)
      .max(50, translate?.auth?.subServiceCharLen_max),
    name_ar: Yup.string()
      .required(translate?.error?.required)
      .min(2, translate?.auth?.subServiceCharLen_min)
      .max(50, translate?.auth?.subServiceCharLen_max),
    price: Yup.string()
      .required(translate?.auth?.priceRequired)
      .min(1, translate?.auth?.priceRequired),
    description: Yup.string().max(500, translate?.auth?.descriptionLimit),
    descriptionAr: Yup.string().max(
      500,
      translate?.auth?.arabicDescriptionLimit
    ),
    selectedService: Yup.array()
      .min(1, translate?.auth?.requiredFeild)
      .required(translate?.auth?.requiredFeild),
  });

  const handleChange1 = (event: SelectChangeEvent) => {
    setSelectField1(event.target.value as string);
  };

  const [errors, setErrors] = useState({
    name: "",
    name_ar: "",
    price: "",
    description: "",
    description_ar: "",
    selectedService: "",
  });

  const validateForm = async () => {
    try {
      await serviceSchema.validate(
        {
          name,
          name_ar,
          price,
          description,
          description_ar,
          selectedService,
        },
        { abortEarly: false }
      );
      setErrors({
        name: "",
        name_ar: "",
        price: "",
        description: "",
        description_ar: "",
        selectedService: "",
      });
      return true;
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const newErrors = {
          name: "",
          name_ar: "",
          price: "",
          description: "",
          description_ar: "",
          selectedService: "",
        };
        err.inner.forEach((error) => {
          if (error.path) {
            newErrors[error.path as keyof typeof newErrors] = error.message;
          }
        });
        setErrors(newErrors);
      }
      return false;
    }
  };

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (await validateForm()) {
      handleSubmit();
    }
  };

  const handleState = () => {
    setSelectedId("");
    setDescription("");
    setName("");
    setPrice("");
    setError(false);
    setSelectedService([]);
    setErrors({
      name: "",
      price: "",
      description: "",
      name_ar: "",
      description_ar: "",
      selectedService: "",
    });
  };

  const [servicesList, setServiceList] = useState<Category[]>([]);

 

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const value = event.target.value as string[];
    setSelectedService(
      value.filter((item) => item !== translate?.user?.selectServices)
    );
  };

  const getAllCategory = async () => {
    try {
      const response = await getMasterMethod({
        parentId: cateId || "",
        type: 1,
      }).unwrap();
      if (response?.statusCode === 200) {
        setServiceList(response?.data);
      }
    } catch (error) {
      showError(translate?.auth?.failedToLoad);
    }
  };

  useEffect(() => {
    getAllCategory();
  }, []);

  return (
    <Modal className="modal addCategory_modal" open={open} onClose={onClose}>
      <div className="modal-dialog w_900">
        <div className="modal-body">
          <div className="modal_title">
            <h2>
              {selectedId
                ? translate?.main?.updateAdOn
                : translate?.main?.addAddOn}
            </h2>
            <div
              className="btn-close"
              onClick={() => {
                handleState();
                setOpen(false);
              }}
            >
              <CloseIcon />
            </div>
          </div>
          <form className="form" onSubmit={handleFormSubmit}>
            <div className="gap_p">
              <div className="control_group w_50">
                <label>{translate?.main?.englishAdOn} <span style={{ color: 'red' }}>*</span></label>
                <TextField
                  placeholder={translate?.user?.enterName}
                  fullWidth
                  hiddenLabel
                  value={name}
                  onChange={(e) => {
                    if (isValidInput(e.target.value)) {
                      setName(e.target.value);
                      setErrors((prev) => ({ ...prev, name: "" }));
                    }
                  }}
                  error={!!errors.name}
                />
                {errors.name && (
                  <span
                    className="error-message"
                    style={{
                      color: "#ff0000",
                      fontSize: "12px",
                      marginTop: "4px",
                      display: "block",
                      fontWeight: "500"
                    }}
                  >
                    {errors.name}
                  </span>
                )}
              </div>

              <div className="control_group w_50">
                <label>{translate?.main?.arabicAdOn} <span style={{ color: 'red' }}>*</span></label>
                <TextField
                  placeholder={translate?.user?.enterName}
                  fullWidth
                  hiddenLabel
                  value={name_ar}
                  onChange={(e) => {
                    if (isValidInput(e.target.value)) {
                      setName_ar(e.target.value);
                      setErrors((prev) => ({ ...prev, name_ar: "" }));
                    }
                  }}
                  error={!!errors.name_ar}
                />
                {errors.name_ar && (
                  <span
                    className="error-message"
                    style={{
                      color: "#ff0000",
                      fontSize: "12px",
                      marginTop: "4px",
                      display: "block",
                      fontWeight: "500"
                    }}
                  >
                    {errors.name_ar}
                  </span>
                )}
              </div>

              <div className="control_group w_50">
                <label>{translate?.globals?.description}</label>
                <TextField
                  variant="outlined"
                  placeholder={translate?.globals?.description}
                  fullWidth
                  hiddenLabel
                  multiline
                  maxRows={5}
                  minRows={5}
                  inputProps={{ maxLength: 500 }}
                  value={description}
                  onChange={(e) => {
                    if (isValidInput(e.target.value)) {
                      setDescription(e.target.value);
                      setErrors((prev) => ({ ...prev, description: "" }));
                    }
                  }}
                  error={!!errors.description}
                />
                {errors.description && (
                  <span
                    className="error-message"
                    style={{
                      color: "#ff0000",
                      fontSize: "12px",
                      marginTop: "4px",
                      display: "block",
                      fontWeight: "500"
                    }}
                  >
                    {errors.description}
                  </span>
                )}
              </div>

              <div className="control_group w_50">
                <label>{translate?.globals?.description}</label>
                <TextField
                  variant="outlined"
                  placeholder={translate?.globals?.description}
                  fullWidth
                  hiddenLabel
                  multiline
                  maxRows={5}
                  minRows={5}
                  value={description_ar}
                  inputProps={{ maxLength: 500 }}
                  onChange={(e) => {
                    if (isValidInput(e.target.value)) {
                      setDescription_ar(e.target.value);
                      setErrors((prev) => ({ ...prev, description_ar: "" }));
                    }
                  }}
                  error={!!errors.description_ar}
                />
                {errors.description_ar && (
                  <span
                    className="error-message"
                    style={{
                      color: "#ff0000",
                      fontSize: "12px",
                      marginTop: "4px",
                      display: "block",
                      fontWeight: "500"
                    }}
                  >
                    {errors.description_ar}
                  </span>
                )}
              </div>

              <div className="control_group w_50">
                <label>{translate?.globals?.price} (BHD) <span style={{ color: 'red' }}>*</span></label>
                <TextField
                  placeholder={translate?.user?.enterPrice}
                  fullWidth
                  hiddenLabel
                  type="text"
                  value={price}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow empty string for backspace functionality
                    if (value === "") {
                      setPrice("");
                      setErrors((prev) => ({ ...prev, price: "" }));
                      return;
                    }

                    // Check if the input matches the pattern: up to 10 digits with up to 2 decimal places
                    const priceRegex = /^\d{1,10}(\.\d{0,2})?$/;

                    if (priceRegex.test(value)) {
                      // Convert to number to check if it's greater than 0
                      const numValue = parseFloat(value);
                      if (numValue > 0) {
                        setPrice(value);
                        setErrors((prev) => ({ ...prev, price: "" }));
                      }
                    }
                  }}
                  onPaste={(e) => {
                    e.preventDefault();
                    const pastedText = e.clipboardData.getData("text");
                    const priceRegex = /^\d{1,10}(\.\d{0,2})?$/;

                    if (priceRegex.test(pastedText)) {
                      const numValue = parseFloat(pastedText);
                      if (numValue > 0) {
                        setPrice(pastedText);
                        setErrors((prev) => ({ ...prev, price: "" }));
                      }
                    }
                  }}
                  inputProps={{
                    pattern: "^\\d{1,10}(\\.\\d{0,2})?$",
                    inputMode: "decimal",
                  }}
                  error={!!errors.price}
                />
                {errors.price && (
                  <span
                    className="error-message"
                    style={{
                      color: "#ff0000",
                      fontSize: "12px",
                      marginTop: "4px",
                      display: "block",
                      fontWeight: "500"
                    }}
                  >
                    {errors.price}
                  </span>
                )}
              </div>

              <div className="control_group w_50">
                <label>{translate?.user?.selectServices} <span style={{ color: 'red' }}>*</span></label>

                <Autocomplete
                  className="users_autocomplete"
                  multiple
                  options={servicesList}
                  disableCloseOnSelect
                  getOptionLabel={(option) =>
                    typeof option?.name === "string" ? option.name : ""
                  }
                  value={servicesList.filter((s) =>
                    selectedService.includes(s._id)
                  )}
                  onChange={(event, newValue) => {
                    const selectedIds = newValue.map((item) => item._id);
                    setSelectedService(selectedIds);
                    setErrors((prev) => ({ ...prev, selectedService: "" }));
                  }}
                  isOptionEqualToValue={(option, value) =>
                    option._id === value._id
                  }
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.name}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={translate?.user?.selectServices}
                      fullWidth
                      error={!!errors.selectedService}
                      helperText={errors.selectedService}
                      FormHelperTextProps={{
                        style: {
                          color: "#ff0000",
                          fontSize: "12px",
                          marginTop: "4px"
                        }
                      }}
                    />
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        label={option.name}
                        {...getTagProps({ index })}
                        key={option._id}
                      />
                    ))
                  }
                  clearOnBlur={false}
                  clearIcon
                />
              </div>
              <div
                className="footer_btn_flex"
                style={{ marginTop: "20px", justifyContent: "flex-start" }}
              >
                <Button
                  className="btn btn_grey"
                  onClick={() => {
                    handleState();
                    setOpen(false);
                  }}
                >
                  {translate?.main?.cancel}
                </Button>
                <Button
                  className="btn btn_primary"
                  type="submit"
                  onClick={() => setError(true)}
                >
                  {selectedId
                    ? translate?.main?.update
                    : translate?.globals?.submit}
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
